export interface IdentityHeroProps {
  title: string;
  subtitle?: string;
  bullets?: readonly string[];
}

export function IdentityHero({ title, subtitle, bullets }: IdentityHeroProps) {
  return (
    <section className="sc-identity-hero" aria-labelledby="sc-identity-hero-title">
      <h1 id="sc-identity-hero-title">{title}</h1>
      {subtitle ? <p>{subtitle}</p> : null}
      {bullets && bullets.length > 0 ? (
        <ul>
          {bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
